export var ArrayUtils;
(function (ArrayUtils) {
    /**
     * Sort an array at random
     * @param array array to randomise
     */
    ArrayUtils.randomSort = (array) => array.sort(() => Math.random() * 2 - 1);
    /**
     * Run a callback a number of times
     * @param callback the callback to run
     * @param iterations the number of times to run it
     */
    ArrayUtils.iterate = (callback, iterations) => new Array(iterations).fill(true).map((_, i) => callback(i));
    /**
     * Replace a value in an array
     * @param array the array to replace at a poosition
     * @param index the index at which to replace it
     * @param newValue the new value at that index of the array
     */
    ArrayUtils.replaceAtI = (array, index, newValue) => {
        const newArray = array;
        newArray[index] = newValue;
        return array;
    };
    /**
     * Finds objects in common between two array and returns those in common
     * @param array1
     * @param array2
     * @param key Optionally check against a key on each object
     */
    ArrayUtils.findInCommon = (array1, array2, key) => array1.filter((value) => array2.some((value2) => (key ? value[key] === value2[key] : value === value2)));
})(ArrayUtils || (ArrayUtils = {}));
